import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { LanguageSwitchComponent } from '@app/layouts/auth/components/language-switch/language-switch.component';
import { ResponsiveService } from '@app/shared/services/responsive/responsive.service';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'math-auth-header',
  imports: [NzColDirective, NzRowDirective, LanguageSwitchComponent, AsyncPipe],
  templateUrl: './auth-header.component.html',
  styleUrl: './auth-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthHeaderComponent {
  public hideLogo = input<boolean>(false);
  public responsive = inject(ResponsiveService);
}
